import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: {
      border: `2px dashed ${palette.lightGray}`,
      background: palette.superLightGray,
      borderRadius: 4,
    },

    content: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '60px 15px',
      marginBottom: 50,
      flexDirection: 'column',
    },

    value: {
      fontSize: 14,
      color: palette.gray,
      lineHeight: 1,
      marginTop: 8,
    },
  });
